import {BaseApiService} from '../../common/base-api.service';
import {AlertNoticeLevel, EntityAlertType, IAlertInfo} from '../models/IAlertInfo.interface';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {SettingsProviderService} from '../../common/settings-provider.service';
import {ICompanyInfo} from '../../message-models/company-info.interface';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {IUserInfo} from '../../users/models/userInfo.interface';
import {IOperativeAlertSummaryInfo} from '../models/OperativeAlertSummaryInfo';


@Injectable({
  providedIn: 'root'
})
export class AlertsService extends BaseApiService {
  alerts: IAlertInfo[];
  alertsCountSubject = new BehaviorSubject<number>(null);
  supervisionAlertsCountSubject = new BehaviorSubject<number>(null);

  // alerts: IAlertInfo[] = [
  //   {
  //     title: 'Operative/s in Danger Category',
  //     detailsHtml: '<p>Operative <b>George Westinghouse</b> is working in a role that is identified as dangerous</p>',
  //     alertLevel: AlertNoticeLevel.Danger
  //
  //   } as IAlertInfo,
  //   {
  //     title: 'Followup/s Due',
  //     detailsHtml: 'A follow up is due for operative Nicola Tesla',
  //     alertLevel: AlertNoticeLevel.Warning
  //   } as IAlertInfo
  // ];
  totalAlerts: number;
  totalSupervisionAlerts: number;

  constructor(http: HttpClient) {
    super(http, new SettingsProviderService('ecaApi'), 'Alerts');
  }


  getSupervisionAlertsCountForCompany(companyId: string): Observable<number> {
      return this.post<number>('GetAlertsCountForCompany', {
        companyId,
        showOnlyRisks: true
      }).pipe(switchMap(totalSupervisionAlerts => {
        this.totalSupervisionAlerts = totalSupervisionAlerts;
        this.supervisionAlertsCountSubject.next(totalSupervisionAlerts);
        return of(this.totalAlerts);
      }));
  }
  getAlertsCountForCompany(companyId: string, includeRisks?: boolean, showOnlyRisks?: boolean): Observable<number> {
    return this.post<number>('GetAlertsCountForCompany', {
      companyId,
      includeRisks,
      showOnlyRisks
    }).pipe(switchMap(totalAlerts => {
      this.totalAlerts = totalAlerts;
      this.alertsCountSubject.next(totalAlerts);
      return of(this.totalAlerts);
    }));
  }
  getCurrentAlerts(companyId: string, includeRisks?: boolean, showOnlyRisks?: boolean): Observable<IAlertInfo[]> {
    return this.post<IAlertInfo[]>('GetAlertInfosForCompany', {
      companyId,
      includeRisks,
      showOnlyRisks
    });
  }
  getSupervisionAlertsForCompany(companyId: string): Observable<IOperativeAlertSummaryInfo[]> {
    return this.post<IOperativeAlertSummaryInfo[]>('GetSupervisionAlertsForCompany', {companyId});
  }

  dismissAlert(companyId: string, alertType: EntityAlertType, entityId: string): Observable<void> {
    return this.post<void>('DismissAlert', {
      companyId,
      alertType,
      entityId
    });
  }
}
